/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { EditorState } from "prosemirror-state";
import { Node, Schema } from "prosemirror-model";
import { Selection } from "prosemirror-state";
import { keymap } from "prosemirror-keymap";
import { baseKeymap } from "prosemirror-commands";
import { storyToPMDoc } from "./story-to-prosemirror";
import { buildKeymap } from "../plugins/keymap";
import { schema, paragraphSchema } from "./schema";
import { DOMParser } from "prosemirror-model";
import textPlaceholder from "../plugins/placeholder";
import linter from "../plugins/linter";
import { toolbar } from "../plugins/toolbar/toolbar";
import { Story } from "api/story";
import { PMElement } from "./types";
import { undo, redo, history } from "prosemirror-history";
import appendTransactions from "../plugins/append-transactions";
import filterTransactions from "../plugins/filter-transactions";
import { safeTextSelection } from "../operations/selection";

const paragraphParser = DOMParser.fromSchema(paragraphSchema);
const schemaParser = DOMParser.fromSchema(schema);

export function makeEditorState(
  story: Story,
  editorState: EditorState<Schema> | {} = {},
  selection: Selection<Schema> | null = null
): EditorState<Schema> {
  const PMStory: PMElement = storyToPMDoc(story, {
    schemaParser,
    paragraphParser,
    editorState
  });

  const PMDoc = Node.fromJSON(schema, PMStory);

  return EditorState.create({
    schema,
    doc: PMDoc,
    selection: selection ? safeTextSelection(PMDoc, selection.anchor, selection.head) : safeTextSelection(PMDoc, 0),
    plugins: [
      history(),
      keymap({ "Mod-z": undo, "Mod-y": redo, "Mod-Shift-z": redo }),
      keymap(buildKeymap(schema)),
      keymap(baseKeymap),
      textPlaceholder(),
      linter(),
      toolbar(),
      filterTransactions(),
      appendTransactions()
    ]
  });
}
